import { includes, indexOf } from 'lodash';

import {
  INFORMATION_PDF_HEADERS_PART_ONE,
  INFORMATION_PDF_HEADERS_PART_TWO,
  INFORMATION_PDF_HEADERS_WITHOUT_POST_CLOSURE,
  STAND_WORKSHEET_PDF_HEADER_VALUES,
} from '@app/shared/types/enums/stand-worksheet-pdf.enum';
import { decimalNumber } from '@app/shared/common';
import { IInformationData } from '@app/shared/types/entities/stand-worksheet';
import { calculatePercentage } from '@app/shared/utils/percentage.utils';
import { IPdfTableHeader } from '@app/shared/common/make-pdf/pdf-table-header.type';

const getPdfTextColor = (
  informationData: IInformationData,
  itemKey: string,
): string => {
  let fontColor = '#323232';
  const diffKeys = [
    STAND_WORKSHEET_PDF_HEADER_VALUES.PhysTerminalDiff,
    STAND_WORKSHEET_PDF_HEADER_VALUES.ReceiptPhysicalDiff,
    STAND_WORKSHEET_PDF_HEADER_VALUES.CashTerminalDiff,
  ];

  const originKeys = [
    STAND_WORKSHEET_PDF_HEADER_VALUES.PhysicalSales,
    STAND_WORKSHEET_PDF_HEADER_VALUES.ReceiptTotal,
    STAND_WORKSHEET_PDF_HEADER_VALUES.CashCount,
  ];

  if (includes(diffKeys, itemKey)) {
    const index = indexOf(diffKeys, itemKey);
    const percentageNumber: number = calculatePercentage(
      informationData[itemKey],
      informationData[originKeys[index]],
    );
    fontColor =
      percentageNumber < 0 || decimalNumber(informationData[itemKey]).lt(0)
        ? '#E32239'
        : fontColor;
  }

  return fontColor;
};

const getInformationFormHeaderWidth = (
  isOffPostClosureSetting: boolean,
): string => (isOffPostClosureSetting ? '7%' : '8.75%');

const getInformationPdfColumns = (
  isOffPostClosureSetting: boolean,
): IPdfTableHeader[] =>
  isOffPostClosureSetting
    ? [
        ...INFORMATION_PDF_HEADERS_PART_ONE,
        ...INFORMATION_PDF_HEADERS_WITHOUT_POST_CLOSURE,
      ]
    : INFORMATION_PDF_HEADERS_PART_ONE;

const getEntryFormPdfColumns = (
  isOffPostClosureSetting: boolean,
): IPdfTableHeader[] =>
  isOffPostClosureSetting ? [] : INFORMATION_PDF_HEADERS_PART_TWO;

export {
  getPdfTextColor,
  getInformationFormHeaderWidth,
  getInformationPdfColumns,
  getEntryFormPdfColumns,
};
